import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import MainLayout from './components/MainLayout';
import AdminLayout from './components/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import PatientsPage from './pages/PatientsPage';
import PatientDetailPage from './pages/PatientDetailPage';
import SessionDetailPage from './pages/SessionDetailPage';
import SessionsPage from './pages/SessionsPage';
import SettingsPage from './pages/SettingsPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import PendingApprovalScreen from './components/PendingApprovalScreen';
import AccountDeactivatedScreen from './components/AccountDeactivatedScreen';
import TrialExpiredScreen from './components/TrialExpiredScreen';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureUpgradeModalProvider } from './contexts/FeatureUpgradeModalContext';
import { FeatureUpgradeModal } from './components/FeatureUpgradeModal';

function App() {
  const { t } = useTranslation();

  return (
    <AuthProvider>
      <FeatureUpgradeModalProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Auth Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />

              {/* Status-specific routes */}
              <Route path="/pending" element={<PendingApprovalScreen />} />
              <Route path="/deactivated" element={<AccountDeactivatedScreen />} />
              <Route path="/trial-expired" element={<TrialExpiredScreen />} />

              {/* Admin Routes */}
              <Route element={<AdminProtectedRoute />}>
                <Route element={<AdminLayout />}>
                  <Route path="/admin" element={<AdminPage />} />
                </Route>
              </Route>

              {/* Protected Routes for therapists */}
              <Route element={<ProtectedRoute />}>
                <Route element={<MainLayout />}>
                  <Route index element={<DashboardPage />} />
                  <Route path="patients" element={<PatientsPage />} />
                  <Route path="patients/:patientId" element={<PatientDetailPage />} />
                  <Route path="patients/:patientId/sessions/:sessionId" element={<SessionDetailPage />} />
                  <Route path="sessions" element={<SessionsPage />} />
                  <Route path="settings" element={<SettingsPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Route>
            </Routes>
          </div>
        </BrowserRouter>
        <FeatureUpgradeModal />
      </FeatureUpgradeModalProvider>
    </AuthProvider>
  );
}

export default App;